import { Box, Input, Slider, Typography } from "@mui/material";
import React from "react";
import { StyledQuestionTypography } from "../../../style/styleComponents/StyledFutureGoal";
import { getColor } from "../../../style/color/color";
import { String } from "../../../constants/Strings";
import { fonts } from "../../../style/fonts/fonts";

const AgeSlider = ({ totalAge, question, onAgeChange }) => {
  const handleAgeChange = (e) => {
    const value = e.target.value;

    // Ensure the value is a valid positive integer and not empty
    if (/^\d+$/.test(value) || value === "") {
      onAgeChange(value);
    }
  };
  return (
    <Box>
      <StyledQuestionTypography>{question}</StyledQuestionTypography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mt: 2,
        }}
      >
        <Input
          fullWidth
          type="tel"
          disableUnderline={true}
          sx={{
            borderRadius: 3,
            border: "0.50px #505662 solid",
            textAlign: "center",
            p: 1,
            mt: "15px",
            width: "80%",
            maxWidth: "300px",
            color: getColor.NeutralDark700,
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: 700,
            wordWrap: "break-word",
            "& input": {
              textAlign: "center",
              fontWeight: "700",
            },
            "&::before": {
              borderBottom: "none",
            },
            "&::after": {
              borderBottom: "none",
            },
          }}
          value={totalAge}
          onChange={handleAgeChange}
          placeholder={String.Retirement.FutureGoal.goalAmountYear}
          inputProps={{
            pattern: "^[0-9]+$",
          }}
        ></Input>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: 10,
          borderRadius: 10,
          pl: "20px",
          pr: "20px",
        }}
      >
        <Slider
          aria-labelledby="input-slider"
          valueLabelDisplay="auto"
          value={Number(totalAge) || 0}
          onChange={(e, newValue) => {
            onAgeChange(e.target.value);
          }}
          min={1}
          max={18}
          step={1}
          sx={{
            width: "90%",
            p: 1,
            mt: "10px",
            mr: "10px",
            ml: "10px",
            color: getColor.ExtendedpalettesSummerSkySS800,
            "& .MuiSlider-thumb": {
              height: 24,
              width: 24,
              backgroundColor: getColor.PrimaryWhite,
              border: "2px solid currentColor",
              "&:hover": {
                boxShadow: "inherit",
              },
            },
            "& .MuiSlider-track": {
              height: 8,
              borderRadius: 4,
            },
            "& .MuiSlider-rail": {
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(0, 0, 0, 0.10)",
            },
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: "0px",
            ml: "12px",
            mr: "20px",
          }}
        >
          <Typography
            sx={{
              fontSize: 12,
              color: getColor.Grey,
            }}
          >
            {`${1} yr`}
          </Typography>

          <Typography
            sx={{
              fontSize: 12,
              color: getColor.Grey,
            }}
          >
            {`${25} yrs`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AgeSlider;
